import { system, space, layout, position, flexbox, color, border, shadow, typography } from "styled-system";
import styled from "styled-components";
const other = system({
  whiteSpace: true,
  pointerEvents: true,
  userSelect: true,
  cursor: true
});
const gridSystem = system({
  area: {
    property: "gridArea"
  },
  columnStart: {
    property: "gridColumnStart"
  },
  columnEnd: {
    property: "gridColumnEnd"
  },
  columnSpan: {
    property: "gridColumnEnd",
    transform: val => `span ${val}`
  },
  rowStart: {
    property: "gridRowStart"
  },
  rowEnd: {
    property: "gridRowEnd"
  },
  rowSpan: {
    property: "gridRowEnd",
    transform: val => `span ${val}`
  },
  gap: {
    property: "gap",
    scale: "space"
  },
  columnGap: {
    property: "columnGap",
    scale: "space"
  },
  rowGap: {
    property: "rowGap",
    scale: "space"
  }
});
export const Box = styled.div.withConfig({
  displayName: "box__Box",
  componentId: "sc-10vs6zk-0"
})(["box-sizing:border-box;min-width:0;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " &[hidden]{display:none !important;}"], space, layout, position, flexbox, color, border, shadow, typography, gridSystem, other);
export default Box;